export const getImagePath = (imagePath) => {
  return `https://api.openskyitschool.com/${imagePath}`;
};
